import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { hamburgNjConfig } from "./data";

export default function HamburgNJPage() {
  return <CityPageTemplate config={hamburgNjConfig} />;
}